import axios from 'axios';

// Create a global Axios instance
const api = axios.create({
  baseURL: '/api', // your backend base URL
  timeout: 10000, // optional
});

// Add a request interceptor to include the year code automatically
api.interceptors.request.use(
  (config) => {
    // Example: get the year code from localStorage or any global state
    const yearCode = localStorage.getItem('yearCode') || '2526';
    config.headers['X-Year-Code'] = yearCode;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
